<template>
  <abf-container>
    <v-layout wrap>
      <v-flex xs12 md5>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>create</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Content</h4>
            </div>
          </v-card-title>
          <v-form lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm8>
                  <v-text-field label="Traceable URL" v-model="updates.traceable_url" />
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Button text" v-model="updates.traceable_label" />
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="pa-0">Comms Content</v-subheader>
                  <vue-editor id="comms" v-model="updates.comms_content" :editorToolbar="toolbarOptions" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent" @click="updateProduct">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 md7>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>email</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Email Preview</h4>
            </div>
          </v-card-title>
          <v-card-text class="pa-3 pt-4">
            <v-layout pt2>
              <v-flex>
                <img alt="partner logo" :src="product.logo" style="width: 190px; height: auto;" />
              </v-flex>
              <v-flex>
                <span class="partner-web-content" v-html="updates.comms_content" />
              </v-flex>
            </v-layout>
            <p style="clear: both; text-align: center;">
              <a
                class="success updates-link"
                :href="updates.traceable_url"
                target="_blank"
                :title="updates.traceable_label"
              >
                {{ updates.traceable_label || 'Continue to quote' }}
              </a>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </abf-container>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { mapActions } from 'vuex';
import AbfContainer from '../../Abf/AbfContainer';
import { toolbarOptions } from '@/utils/vueEditorConfig';

export default {
  components: {
    AbfContainer,
    VueEditor
  },
  name: 'funder-comms',
  props: ['product'],
  data: () => ({
    toolbarOptions,
    updates: {
      traceable_url: null,
      traceable_label: null,
      comms_content: null
    }
  }),
  methods: {
    ...mapActions(['updateFunder', 'addNotification']),
    updateProduct() {
      this.updateFunder({ id: this.product.id, updates: this.updates });
    }
  },
  watch: {
    product: {
      immediate: true,
      handler() {
        this.updates.traceable_url = this.product.traceable_url;
        this.updates.traceable_label = this.product.traceable_label;
        this.updates.comms_content = this.product.comms_content;
      }
    }
  }
};
</script>

<style scoped>
.updates-link {
  background-color: #89c731;
  border-radius: 3px;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  letter-spacing: normal;
  line-height: 100%;
  margin: 0 10px;
  padding: 10px;
  text-align: center;
  text-decoration: none;
}
</style>
